<div class="dialogCustom--maxHeight">
  <div mat-dialog-title>
    <div class="h4 mb-0">{{data.title}}</div>
    <button mat-icon-button (click)="onCancel()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <ng-container [formGroup]="onlineApprovalForm">
      <section>
        <ng-container *ngIf="(isCurrentUser && !onlineApproval); else statusTemplate">
          <mat-button-toggle-group formControlName="approveStatus">
            <mat-button-toggle [value]="ApproveStatus.Accepted">
              <mat-icon svgIcon="check"></mat-icon>
              {{data?.customNames?.approvalAcceptCustomName}}
            </mat-button-toggle>
            <mat-button-toggle [value]="ApproveStatus.Rejected">
              <mat-icon svgIcon="cancel"></mat-icon>
              {{data?.customNames?.approvalRejectCustomName}}
            </mat-button-toggle>
            <mat-button-toggle [value]="ApproveStatus.Seen">
              <mat-icon svgIcon="eye"></mat-icon>
              {{data?.customNames?.approvalSeenCustomName}}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </ng-container>
        <ng-template #statusTemplate>
          <app-chip
            [icon]="onlineApproval | approveStatusIcon : 'approveStatus' : false : true"
            [color]="onlineApproval | approveStatusColor : 'approveStatus'"
            [label]="onlineApproval | approveStatusText : data?.customNames : 'approveStatus'"
          ></app-chip>
        </ng-template>
      </section>
      <section class="mt-3">
        <ng-container
          *ngIf="(data?.dprOnlineApprover?.isCurrentUser && data?.dprOnlineApprover?.canApprove); else commentTemplate"
        >
          <div class="mb-2 font-weight-bold" i18n="@@dpr.dprOnlineApproveModal.lblYourComment">Your comment</div>
          <mat-form-field appearance="fill" class="w-100">
            <textarea matInput rows="5" maxlength="1000" spellcheck="true" formControlName="comment"></textarea>
          </mat-form-field>
        </ng-container>
        <ng-template #commentTemplate>
          <div class="mb-2 font-weight-bold" i18n="@@dpr.dprOnlineApproveModal.lblComment">Comment</div>
          <div>{{onlineApproval?.comment}}</div>
        </ng-template>
      </section>
    </ng-container>
  </div>

  <div mat-dialog-actions>
    <ng-container *ngIf="isCurrentUser && canApprove; else closeButtonTemplate">
      <button mat-flat-button color="primary" [disabled]="!approveStatus" (click)="onSave()" cdkFocusInitial>
        <mat-icon svgIcon="check"></mat-icon>
        {{staticMessage.SaveButton | staticMessage}}
      </button>
      <button mat-button color="primary" (click)="onCancel()">{{staticMessage.CancelButton | staticMessage}}</button>
    </ng-container>
    <ng-template #closeButtonTemplate>
      <button mat-button color="primary" (click)="onCancel()">{{staticMessage.CloseButton | staticMessage}}</button>
    </ng-template>
  </div>
</div>
